import React, { useState } from "react";
import { formServices } from "../../../services/formServices";
import Select from "react-select"

const FeeGroupForm = () => {

    const [course , setCourse] = useState("");
    const [groupname , setGroupname] = useState("")

    const handlePost = () => {
        return formServices.feegroupPost(course , groupname)
    }

    const courses = [
        {label: "Information Technology", value: "it"},
        {label: "CSE", value: "cse"},
        {label: "Demo", value: "demo"}
    ]

    return (
        <div className="text-sm bg-white pt-4 px-5 pb-4  w-11/12 mx-auto rounded-md">
            <p className="text-xl font-bold gg-erp-color ">FEE GROUP</p>
            
            <label for="crse" className="mb-2 w-full py-2">Course
            <Select 
                options={courses}
                value={course}
                onChange = {(option)=>setCourse(option)}
                placeholder="Select Course" 
                isClearable={true} 
                theme={(theme) => ({
                    ...theme,
                    borderRadius: 4,
                    colors: {
                    ...theme.colors,
                    primary25: 'lightCyan',
                    primary: '#ff5722',
                    },
                })}
            />
            </label>

            <label for="grp" className="mb-2 w-full py-2">Group Name
                <input className="form-input" placeholder="Group Name" type="text" name="grp" onChange={e => setGroupname(e.target.value)}/>
            </label>

            <hr/>
            <div className="text-right mt-2">
                <button type="submit" className="submit" onClick = {handlePost}>Submit</button>
            </div>
        </div>
    )
}

export default FeeGroupForm